const profile = {
    name: '名稱',
    avatar: '頭像',
    givenName: '名字',
    familyName: '姓氏',
    middleName: '中間名',
    fullName: '全名',
    nickname: '暱稱',
    preferredUsername: '偏好用戶名',
    profile: '個人資料',
    website: '網站',
    gender: '性別',
    birthdate: '出生日期',
    zoneinfo: '時區資訊',
    locale: '語言地區',
    address: {
        formatted: '地址',
        streetAddress: '街道地址',
        locality: '城市',
        region: '州／省份',
        postalCode: '郵遞區號',
        country: '國家',
    },
};
export default Object.freeze(profile);
